import type {AppThunk} from '../../../actions/types'
import {restApi} from '../../../services/rest'
import type {ProjectId} from '../../../types'
import type {Refetchable} from '../../../utils/refetchable'

export const preloadBuildStepSelector =
  (projectId: ProjectId): AppThunk<Refetchable> =>
  dispatch =>
    dispatch(restApi.endpoints.getPublicRecipesMode.initiate({projectId}))
